import { Navigate, useParams } from 'react-router-dom'
import { useChallengeResolution } from '../../hooks/challenge/useChallengeId'
import { useTeam } from '../../hooks/team/useTeam'
import styles from '../../ui/onboarding/GuardView.module.css'
import LoadingIndicator from '../../ui/util/LoadingIndicator'
import TeamScreen from '../../screens/TeamScreen'
import { hiddenChallengeDestination } from './ChallengeRoute'

/** `/team/:teamID`. A team on a test challenge sends non-admins away. */
export default function TeamRoute() {
  const { teamID } = useParams()
  const { data: team, isLoading } = useTeam(teamID ?? '')
  const resolution = useChallengeResolution()

  if (resolution.isResolving || (teamID && isLoading)) {
    return (
      <div className={styles.loading}>
        <LoadingIndicator />
      </div>
    )
  }

  if (team && !resolution.canSee(team.challengeID)) {
    return <Navigate to={hiddenChallengeDestination(resolution.hasVisibleWorkspace)} replace />
  }

  return <TeamScreen />
}